import { DeliveryProvider, OFFER_KIND, PaymentMethod } from '../../../../../services/exports/Constants';

export default {
  customer_info: {
    dummy_order: 'Testordre',
    ordered_at: 'Bestilt kl.:',
  },
  delivery_info: {
    info: 'Leveringsinfo:',
  },
  order_note: {
    label: 'Ordrenote:',
  },
  schedule_info: {
    pickup: 'Afhentning',
    delivery: 'Levering',
    room_service_location: {
      room_service: 'Værelse',
      table_service: 'Bord',
    },
    wish_time: 'Ønsket tid:',
    confirmed_time: 'Bekræftet tid:',
    driver_arrival_time: 'Chaufførens afhentningstid:',
    external_delivery: 'Ordren leveres af en ekstern chauffør fra {{carrier}}',
  },
  products: {
    item: 'Vare:',
  },
  discount_breakdown: {
    label: 'Rabat',
    [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: 'Procentrabat på samlet beløb anvendt',
    [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: 'Procentrabat på produkter anvendt',
    [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: 'Beløbsrabat på produkter anvendt',
    [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: 'Beløbsrabat på samlet beløb anvendt',
    [OFFER_KIND.BOGO]: 'Køb én, få én gratis anvendt',
    [OFFER_KIND.BOGO_HALF_PRICE]: 'Køb én, få én til halv pris anvendt',
    [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: 'Gratis vare ved produkter anvendt',
    [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: 'Gratis vare ved samlet beløb anvendt',
    GiftCard: 'Gavekort anvendt',
    Reward: 'Loyalitetspoint anvendt',
    CashbackAccount: 'Loyalitetspoint anvendt',
    PromoCodeComponent: 'Kampagne anvendt',
    Offer: 'Tilbud anvendt',
  },
  payment_breakdown: {
    price: 'Pris:',
    subtotal: 'Subtotal',
    delivery_fee: 'Leveringsgebyr',
    tips: 'Drikkepenge',
    processing_fee: 'Onlineservicegebyr',
    payment_method_upcharge_fee: {
      [PaymentMethod.Paypal]: 'PayPal-gebyr',
    },
    tax: 'Skatter',
    total: 'I alt',
    paid_amount: 'Betalt beløb',
    order_not_paid: 'Ordren er endnu ikke betalt',
    order_paid_online: 'Allerede betalt online',
    cash: 'Betaling på stedet',
    this_is_not_an_invoice: 'Dette er ikke en faktura',
  },
  delivery_qr_code: {
    scan: 'Scan og lever med Google Maps',
  },
  delivery_providers: {
    [DeliveryProvider.UberDrive]: 'Uber',
    [DeliveryProvider.FirstDelivery]: 'Uber',
    [DeliveryProvider.WoltDrive]: 'Wolt',
  },
};
